import { useListTranslation } from './use-list-translation'
import { Box, Typography } from '@mui/material'

interface DataGridHeaderProps {
  field: string
}

export function DataGridHeader({ field }: DataGridHeaderProps) {
  const { tl } = useListTranslation()
  const [entityName, columnName] = tl(field)

  return (
    <Box>
      <Typography component='p' variant='caption'>
        {entityName}
      </Typography>
      <Typography variant='body2' sx={{ fontWeight: theme => theme.typography.fontWeightMedium }}>
        {columnName}
      </Typography>
    </Box>
  )
}
